module.exports = __webpack_public_path__ + "static/media/img_carrousel03.2b0dbaba.svg";